var React = require('react');

function SketchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M87.099 26.491c-.045-.093-.14-.14-.198-.223l.049-.034L70.586 2.596a1.812 1.812 0 0 0-1.368-.762v-.016L43.755.018c-.058-.004-.113-.014-.17-.013L43.509 0 18.054 1.818l.001.016a1.802 1.802 0 0 0-1.368.762L.323 26.234l.049.034c-.058.083-.154.13-.198.223a1.822 1.822 0 0 0 .238 1.932L42.23 79.336a1.825 1.825 0 0 0 2.813 0L86.86 28.423c.444-.543.54-1.296.238-1.932zm-5.115-1.036h-9.393l-1.17-15.261 10.563 15.26zM48.635 3.997L67.4 5.337l1.339 17.423L48.635 3.997zm17.662 21.458h-45.32l22.66-21.15 22.66 21.15zM18.534 22.76l1.339-17.424 18.782-1.355-20.121 18.78zm49.338 6.33L43.636 74.334 19.401 29.09h48.471zm-53.19-3.635H5.287l10.564-15.261-1.17 15.26zm.594 3.636l18.021 33.64-27.633-33.64h9.612zm38.7 33.64l18.021-33.64h9.612L53.975 62.73z"}));
}

SketchInline.defaultProps = {"viewBox":"0 0 88 80"};

module.exports = SketchInline;

SketchInline.default = SketchInline;
